import { useEffect, useState } from "react";

import { MoonIcon, SunIcon } from "./ui/ActionIcons";
import { IconButton } from "./ui";
import {
  applyTheme,
  resolveInitialTheme,
  storeTheme,
  type AppTheme,
} from "../lib/theme";

function nextTheme(theme: AppTheme): AppTheme {
  return theme === "dark" ? "light" : "dark";
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState<AppTheme>(() =>
    resolveInitialTheme(typeof window === "undefined" ? undefined : window),
  );

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const targetTheme = nextTheme(theme);
  return (
    <IconButton
      type="button"
      size="sm"
      tone="quiet"
      className="workspace-theme-toggle"
      label={`Switch to ${targetTheme} mode`}
      tooltip={`Switch to ${targetTheme} mode`}
      aria-pressed={theme === "dark"}
      icon={theme === "dark" ? <SunIcon /> : <MoonIcon />}
      onClick={() => {
        setTheme(targetTheme);
        storeTheme(targetTheme);
      }}
    />
  );
}
